import React from "react";
import { connect } from "react-redux";
import LeftMenu from "../leftSideComponent/LeftSide";
import history from "../../auth/history";
import AddConsumerDetails from "./AddConsumerDetails";
import AddConsumerList from "./AddConsumerList";
import Header from "../headerComponent/Header";
import { Link } from "react-router-dom";
import AddedConsumerSubComp from "./AddedConsumerSubComp";
class AddedConsumerDetails extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			phoneNo: this.props.phone,
		}
	}


	componentDidMount() { }
	componentWillUnmount() {
	}


	render() {

		return (
			<div>
				<div class="main">
					<LeftMenu />

					<div class="right-side">
						<div class="container-fluid">

							<Header />
							<div class="row">
								<div class="col-12 col-lg-8">
									<div class="card">
										<div class="dashhead">
											<h3>Add Consumer Details</h3>

											<div class="backbtn">
												<Link to="/add-new-consumer">
													<button type="button" class="back"
													>Back</button>
												</Link>
											</div>
										</div>

										<AddConsumerDetails />


									</div>
								</div>

								<AddedConsumerSubComp />

								{/* <div class="col-12 col-lg-4">
									<div class="card">
										<div class="dashhead">
											<h3>Added Consumer</h3>
											<Link to="/all-consumer" class="lbbtn">View all</Link>
										</div>
										<AddConsumerList />
									</div>
								</div> */}
							</div>
						</div>
					</div>
				</div>
				<div class="footer-txt">Copyright &copy; 2021 All rights reserved. <br />Powered by FinXpay Solutions Pvt. Ltd.</div>
			</div>

		);
	}
}

const mapStateToProps = (
	{ errorMessageReduce: { errorMessage },
		miscReduce: { phone } }
) => ({
	errorMessage, phone
});

export default connect(mapStateToProps, null)(AddedConsumerDetails);
